module.exports = __webpack_public_path__ + "img/footer-wx.17be93df.png";